import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=776286cb&scoped=true&"
import script from "./QuestionInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776286cb",
  null
  
)

export default component.exports